import {Component, OnInit} from '@angular/core';
import {
  CompanyService, KnownFeatureFlags,
  VerificationStatusEnum,
  VerificationStatusService
} from "@brightside-web/desktop/data-access/shared";
import { Subscription, tap, first } from 'rxjs';
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {
  BsAuthService
} from "@brightside-web/desktop/data-access/core-services";
import {Intercom} from "ng-intercom";
import {Environment} from "@brightside-web/micro/core/environment";
import {LanguageSelectorService} from "@brightside-web/desktop/feature/language-selection";
import {FeatureFlagService} from "@brightside-web/desktop/data-access/core-services";


interface stepsObjects {
  label: string;
  details?: string;
  status: string;
}

@Component({
  selector: 'brightside-web-verification-status',
  templateUrl: './verification-status.component.html',
  styleUrls: ['./verification-status.component.scss']
})
export class VerificationStatusComponent implements OnInit {

  private sub = new Subscription();
  company = '';
  processing: boolean;
  allTheSteps: stepsObjects[];
  statusType: string;
  verificationDescKey = "";


  constructor(
    private companyService: CompanyService,
    private router: Router,
    private translateService: TranslateService,
    private intercom: Intercom,
    private env: Environment,
    private verificationStatusSvc: VerificationStatusService,
    private languageSelectSvc: LanguageSelectorService,
    private featureFlagService: FeatureFlagService,
    private bsAuthService: BsAuthService,
    private featureFlagSvc: FeatureFlagService
  ) {}

  ngOnInit() {
    if (this.languageSelectSvc.activeLang !== 'en') {
      this.languageSelectSvc.use(this.languageSelectSvc.activeLang);
    }
    this.sub.add(
      this.companyService.company.subscribe(
        value => {
          this.company = value;
        }
      )
    );
    this.sub.add(
      this.verificationStatusSvc.getEmploymentVerificationStatusFromAPI().subscribe(
        status => {
          this.setSteps(status.employment_data_verification_status.status);
        }
      )
    );
  }

  setSteps(statusType: VerificationStatusEnum) {
    if (statusType === VerificationStatusEnum.VERIFIED) {
      this.statusType = 'verified';
      this.verificationDescKey = "VERIFICATION_STATUS_VERIFIED_DESC";
      this.sub.add(
        this.translateService.get('VERIFICATION_SUBMITTED').subscribe(
          translation => {
            this.allTheSteps = [
              {
                label: translation,
                status: 'complete'
              },
              {
                label: this.translateService.instant('VERIFICATION_VALIDATING'),
                status: 'complete'
              },
              {
                label: this.translateService.instant('VERIFICATION_COMPLETE'),
                status: 'complete'
              }
            ];
          }
        )
      );
    } else {
      this.statusType = 'pending';
      this.verificationDescKey = "VERIFICATION_STATUS_DESC";
      this.sub.add(
        this.translateService.get('VERIFICATION_SUBMITTED').subscribe(
          translation => {
            this.allTheSteps = [
              {
                label: translation,
                status: 'complete'
              },
              {
                label: this.translateService.instant('VERIFICATION_VALIDATING'),
                details: this.translateService.instant('VERIFICATION_VALIDATING_DESC'),
                status: 'current'
              },
              {
                label: this.translateService.instant('VERIFICATION_COMPLETE'),
                status: 'incomplete'
              }
            ];
          }
        )
      );
    }
  }

  continue() {
    this.processing = true;

      this.bsAuthService.fetchUserAttributes(true).subscribe(
        attributes => {
          const intercomUserId = attributes['intercom_external_id'];
          if (intercomUserId) {
            const regex = /%1\$s/gi;
            const data = {
              app_id: this.env.intercomAppId,
              widget: {
                activator: '#intercom',
              },
              name: attributes['first_name'] + ' ' + attributes['last_name'],
              phone: attributes['phone_number'],
              email: attributes['email'],
              user_id: intercomUserId,
              guid: attributes['guid'],
              company: attributes['company'],
              'crm link': this.env.crmUrl.replace(regex, attributes['sf_contact_id'] as string),
            };
            this.featureFlagSvc.getFlag(KnownFeatureFlags.ENABLESALESFORCEMESSAGING)
              .pipe(
                tap(enableSalesforce => {
                  if(!enableSalesforce) {
                    this.intercom.boot(data);
                  }
                })
              )
              .subscribe();
          }
          this.featureFlagService.featureFlagsReady.pipe(
            first(ready => ready)
          ).subscribe(() => {
            this.router.navigate(['onboarding']);
          });

          this.featureFlagService.initializeFeatureFlag(attributes);

        }
    )
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
